import { api } from "./api";

// Lista de personagens pré-carregada: o clique em "Jogar" só precisa pedir o ticket (1 requisição em vez de 2).
let cache = null, at = 0, inflight = null;
export function prefetchChars() {
  if (inflight) return inflight;
  inflight = api.get("/characters").then((r) => { cache = r.data?.data || []; at = Date.now(); return cache; }).catch(() => null).finally(() => { inflight = null; });
  return inflight;
}
export async function getChars() {
  if (cache && Date.now() - at < 60000) return cache;
  const r = await prefetchChars();
  if (r) return r;
  const res = await api.get("/characters");
  return res.data?.data || [];
}
export function clearCharsCache() { cache = null; }
